import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Trash from 'jsx/elements/buttons/Trash';

class FileUpload extends Component {
  fileInputRef = React.createRef();
  fileInputFormRef = React.createRef();

  constructor(props) {
    super(props);
    this.click = this.click.bind(this);
    this.changeFile = this.changeFile.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.state = {
      chosenFile: null
    };
  }

  click() {
    this.fileInputRef.current.click();
  }

  changeFile(e) {
    const file = e.target.files.length > 0 ? e.target.files[0] : null;
    if (file) {
      this.setState({ chosenFile: file });
      if (this.props.onUpdate) {
        this.props.onUpdate(file);
      }
    }
  }

  removeFile() {
    this.setState({ chosenFile: null });
    // If the user removes the chosen file but selects the same file again,
    // the onChange handler doesn't fire (same file is still stored in the form).
    // Therefore need to reset the form itself when the file's removed by the user.
    this.fileInputFormRef.current.reset();
    if (this.props.onUpdate) {
      this.props.onUpdate(null);
    }
  }

  render() {
    const { disabled, hideUploadTextAfterChosenFile } = this.props;
    let uploadTextCls = 'button link icon-upload3';
    if (disabled) {
      uploadTextCls += ' disabled';
    }
    return (
      <div className="form-file-upload">
        <form ref={this.fileInputFormRef}>
          <input
            ref={this.fileInputRef}
            name="file"
            type="file"
            onChange={this.changeFile}
            accept={this.props.accept}
          />
        </form>
        <span className={uploadTextCls} onClick={disabled ? null : this.click}>
          {hideUploadTextAfterChosenFile && this.state.chosenFile
            ? this.state.chosenFile.name
            : this.props.uploadText}
        </span>
        {this.state.chosenFile && !hideUploadTextAfterChosenFile && (
          <span className="text-gray text-14 file-name">
            {this.state.chosenFile.name}
            <span className="trash-file">
              <Trash disabled={disabled} onClick={this.removeFile} />
            </span>
          </span>
        )}
        {this.state.chosenFile && hideUploadTextAfterChosenFile && (
          <span className="text-gray text-14">
            <span className="trash-file">
              <Trash disabled={disabled} onClick={this.removeFile} />
            </span>
          </span>
        )}
      </div>
    );
  }
}

FileUpload.propTypes = {
  uploadText: PropTypes.string.isRequired,
  accept: PropTypes.string,
  onUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  hideUploadTextAfterChosenFile: PropTypes.bool
};

FileUpload.defaultProps = {
  uploadText: 'Sækja skrá',
  accept: '.xlsx, .csv, .txt',
  disabled: false,
  hideUploadTextAfterChosenFile: false
};

export default FileUpload;
